import { styled, theme } from '@clickcease/cc-client-components-lib'

export const ModalTitleWrapper = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '$2',
})

export const ModalTitle = styled('span', {
  variants: {
    emphasis: {
      true: {
        color: '$primaryColor',
      },
    },
  },
})

// Body
export const ModalBody = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$12',
  maxWidth: '90vw',
  pointerEvents: 'none',
})

export const ModalBodyTitle = styled('span', {
  fontSize: '$lg',
  fontWeight: '$r',
})

export const ModalBodyItemsWrapper = styled('div', {
  display: 'flex',
  gap: '$12',
})

export const ModalBodyItemWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
})

export const ModalBodyItemTitle = styled('div', {
  fontSize: '$md',
  fontWeight: '$r',
  color: '$black',
})

export const ModalBodyItemDescription = styled('div', {
  fontSize: '$md',
  color: '$darkGray',
  marginBottom: '$5',
})

export const ModalBodyItemCard = styled('div', {
  width: '100%',
  borderRadius: '$normal',
  border: '1px solid $lightGray',
  marginTop: 'auto',
})

const gridStyle = {
  display: 'grid',
  gridTemplateColumns: '1fr 1.2fr',
  alignItems: 'center',
}

export const ModalBodyItemCardHeader = styled('div', {
  ...gridStyle,
  margin: '$5 $8',
  borderBottom: '1px solid $lightGray',

  // Table like columns
  span: {
    padding: '0 $4 $2 $4',
  },
})

export const ModalBodyItemCardBody = styled('div', {
  ...gridStyle,
  position: 'relative',
  minHeight: theme.space['20'].value,
  margin: '0 $8 $9 $8',

  'span,button': {
    marginLeft: '$4',
  },
  '> svg': {
    position: 'absolute',
    top: '$7',
    left: 'calc(50% + $20)',
  },

  variants: {
    firstItem: {
      true: {
        button: {
          paddingLeft: '0',
        },
      },
      false: {
        '> svg': {
          top: '$9',
          left: 'calc(50% + 76px)',
        },
      },
    },
  },
})
